import { render } from "./EnbLabel.vue?vue&type=template&id=45da663e&scoped=true"
import script from "./EnbLabel.vue?vue&type=script&lang=js"
export * from "./EnbLabel.vue?vue&type=script&lang=js"

import "./EnbLabel.vue?vue&type=style&index=0&id=45da663e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45da663e"]])

export default __exports__